module.exports = __webpack_public_path__ + "img/black-main-menu.7f785a95.svg";